exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dataTable{border-bottom:1px solid rgba(0,0,0,.12);border-radius:0}.dataTable .v-data-table-header tr th span{font-size:14px!important}.edit:hover{color:#009efb}.delete:hover{color:#f44336}.changes:hover{color:#fbc02d}a{text-decoration:none}.filter-btn{font-weight:600}.filter-btn:hover{background-color:rgba(25,118,210,.08)!important}", ""]);

// exports
